function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 2.5C12.2761 2.5 12.5 2.27614 12.5 2C12.5 1.72386 12.2761 1.5 12 1.5C11.7239 1.5 11.5 1.72386 11.5 2C11.5 2.27614 11.7239 2.5 12 2.5Z",
  fill: "#383A36"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19 5.5C19.2761 5.5 19.5 5.27614 19.5 5C19.5 4.72386 19.2761 4.5 19 4.5C18.7239 4.5 18.5 4.72386 18.5 5C18.5 5.27614 18.7239 5.5 19 5.5Z",
  fill: "#383A36"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2.5 12C2.5 12.2761 2.27614 12.5 2 12.5C1.72386 12.5 1.5 12.2761 1.5 12C1.5 11.7239 1.72386 11.5 2 11.5C2.27614 11.5 2.5 11.7239 2.5 12Z",
  fill: "#383A36"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 22C12.5 22.2761 12.2761 22.5 12 22.5C11.7239 22.5 11.5 22.2761 11.5 22C11.5 21.7239 11.7239 21.5 12 21.5C12.2761 21.5 12.5 21.7239 12.5 22Z",
  fill: "#383A36"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M5.5 5C5.5 5.27614 5.27614 5.5 5 5.5C4.72386 5.5 4.5 5.27614 4.5 5C4.5 4.72386 4.72386 4.5 5 4.5C5.27614 4.5 5.5 4.72386 5.5 5Z",
  fill: "#383A36"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M5 19.5C5.27614 19.5 5.5 19.2761 5.5 19C5.5 18.7239 5.27614 18.5 5 18.5C4.72386 18.5 4.5 18.7239 4.5 19C4.5 19.2761 4.72386 19.5 5 19.5Z",
  fill: "#383A36"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 19C19.5 19.2761 19.2761 19.5 19 19.5C18.7239 19.5 18.5 19.2761 18.5 19C18.5 18.7239 18.7239 18.5 19 18.5C19.2761 18.5 19.5 18.7239 19.5 19Z",
  fill: "#383A36"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z",
  fill: "#383A36"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5 12C22.5 12.2761 22.2761 12.5 22 12.5C21.7239 12.5 21.5 12.2761 21.5 12C21.5 11.7239 21.7239 11.5 22 11.5C22.2761 11.5 22.5 11.7239 22.5 12Z",
  fill: "#383A36"
});

var SvgSunIcon = function SvgSunIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSunIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sun-icon.1eb00acc.svg";
export { ForwardRef as ReactComponent };